export default {"src":"/_next/static/media/bg-shape-yellow.292c2f56.svg","height":189,"width":1377,"blurWidth":0,"blurHeight":0};